{{ 'rtr.header.sign_in_text' | translate }}
<span routerLink="/auth/sign_in" margin-left-small-xx>
  {{ 'rtr.header.sign_in' | translate }}
</span>
